import { render } from "./AddressForm.vue?vue&type=template&id=357a94d6"
import script from "./AddressForm?vue&type=script&lang=js&external"
export * from "./AddressForm?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__